var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue2Dropzone',{ref:"myVueDropzone",attrs:{"id":"hiddenDropzone","awss3":_vm.awss3,"destroyDropzone":false,"options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.fileUploaded,"vdropzone-file-added":_vm.fileAdded}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }